import { makeRequest } from "./api";

// Dashboard summary (pending count, owed, paid this month, total paid)
export const FetchPayoutSummary = async () => {
  return makeRequest("/api/admin/manage/payouts/summary");
};

// Paginated host balances
export const FetchHostBalances = async (page, limit) => {
  return makeRequest(
    `/api/admin/manage/payouts/hosts?page=${page}&limit=${limit}`,
  );
};

// Single host payout details (unpaid reservations, bank account, summary)
export const FetchHostPayoutDetails = async (hostId) => {
  return makeRequest(`/api/admin/manage/payouts/hosts/${hostId}`);
};

// Paginated payout list with optional filters
export const FetchPayouts = async (page, limit, status, hostId) => {
  let url = `/api/admin/manage/payouts/fetchPage?page=${page}&limit=${limit}`;
  if (status) url += `&status=${status}`;
  if (hostId) url += `&hostId=${hostId}`;
  return makeRequest(url);
};

// Single payout detail
export const FetchPayoutDetail = async (payoutId) => {
  return makeRequest(`/api/admin/manage/payouts/fetchOne/${payoutId}`);
};

// Create a payout
export const CreatePayout = async (data) => {
  return makeRequest("/api/admin/manage/payouts/create", {
    method: "POST",
    data,
  });
};

// Update payout status
export const UpdatePayoutStatus = async (payoutId, data) => {
  return makeRequest(`/api/admin/manage/payouts/updateStatus/${payoutId}`, {
    method: "PUT",
    data,
  });
};

// Send SMS to host to add bank account
export const SendAddBankAccountSms = async (hostId) => {
  return makeRequest(
    `/api/admin/manage/payouts/hosts/${hostId}/sms/add-bank-account`,
    { method: "POST" },
  );
};

// Send SMS to host about bank details issue on a failed payout
export const SendBankDetailsIssueSms = async (payoutId) => {
  return makeRequest(
    `/api/admin/manage/payouts/${payoutId}/sms/bank-details-issue`,
    { method: "POST" },
  );
};
